import React, { useEffect } from 'react';
import ReactRouterPrompt from 'react-router-prompt';
import { useLocation, useNavigate, useOutletContext } from 'react-router';
import { RemindModalContent } from './RemindModalContent.tsx';

type OwnProps = {
  isActive: boolean;
  saveChangesFunc: (
    _: undefined,
    isSubmitFromModal: boolean,
  ) => Promise<boolean>;
};

type OutletContext = {
  isTryingToLogout: boolean;
  setIsTryingToLogout: (value: boolean) => void;
  logout: () => void;
};

const fakeRedirect = 'fakeRedirect';

export const RemindModalPageDesigner = (props: OwnProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { isActive, saveChangesFunc } = props;

  const { logout, setIsTryingToLogout, isTryingToLogout }: OutletContext =
    useOutletContext();

  useEffect(() => {
    if (isActive && isTryingToLogout) {
      // we need this for firing remind modal blocker func
      void navigate(location.pathname);
    } else if (!isActive && isTryingToLogout) {
      logout();
    }
  }, [isActive, isTryingToLogout]);

  return (
    <ReactRouterPrompt
      when={(args) => {
        if (!args) return false;
        return isActive && args?.nextLocation.state !== fakeRedirect;
      }}
      // we need to resolve Promise in order to call onConfirm and onCancel functions
      beforeConfirm={() => {
        if (isTryingToLogout) {
          logout();
        }

        return new Promise((res) => res(null));
      }}
      beforeCancel={() => {
        setIsTryingToLogout(false);
        return new Promise((res) => res(null));
      }}
    >
      {({ isActive, onConfirm, onCancel }) =>
        isActive &&
        (() => {
          const handleSubmit = async () => {
            const result = await saveChangesFunc(undefined, true);
            if (result) {
              onConfirm();
            } else {
              onCancel();
            }
          };

          return (
            <RemindModalContent
              onClose={onCancel}
              onCancel={onConfirm}
              onSubmit={handleSubmit}
            />
          );
        })()
      }
    </ReactRouterPrompt>
  );
};
